import React from 'react';
import { Badge } from 'src/design/atoms/Badge';
import { resolveWorkflowButtonColor } from 'src/utils';
import { resolveLifecycleColor } from 'src/app/workflows/workflowLifecycle';

export interface IWorkflowStatusBadgeProps {
  status?: string | null;
  buttonColor?: string | null;
}

/**
 * @registry Status badge for job workflow rows (Changes/RFIs/Submittals). Colours from the active step's buttonColor when set (filled), else the shared workflow-lifecycle color for the status, else gray (light).
 */
export const WorkflowStatusBadge: React.FC<IWorkflowStatusBadgeProps> = ({
  status,
  buttonColor,
}) => {
  const stepColor = buttonColor
    ? resolveWorkflowButtonColor(buttonColor)
    : undefined;
  const color = stepColor ?? resolveLifecycleColor(status) ?? 'gray';
  const variant = stepColor ? 'filled' : 'light';
  return (
    <Badge color={color} variant={variant}>
      {(status ?? '').toUpperCase()}
    </Badge>
  );
};
